import React from 'react';
import { OverlayDrawerComponentProps } from '@sharefiledev/sharefile-appshell';
import { PreConfiguredBlock } from '@sharefiledev/solution-view-engine';
import { ClientContact } from '../generated';
import { usePiralEventListener } from '../hooks/usePiralEventListener';

interface ClientContactUpdateDrawerProps
	extends OverlayDrawerComponentProps<'urn:sfdrawer:client-mgt-pilet:client-contact:update'> {}

export const ClientContactUpdateDrawer: React.FC<ClientContactUpdateDrawerProps> = ({
	piral,
	completeInteraction,
	cancelInteraction,
	options,
}) => {
	const completeCallback = ({ clientContact }: { clientContact: ClientContact }) => {
		completeInteraction({ clientContact });
	};
	usePiralEventListener(
		piral,
		'urn:sfdrawer:client-mgt-pilet:client-contact-update-complete',
		'urn:sfdrawer:client-mgt-pilet:client-contact-update-cancel',
		completeCallback,
		cancelInteraction
	);

	const clientRID = options?.clientRID;
	const clientContactRID = options?.clientContactRID;
	if (!clientRID || !clientContactRID) {
		return <div data-testid="client-contact-update-drawer-missing-prop"></div>;
	}
	return (
		<div
			data-testid="client-contact-update-drawer"
			style={{ margin: '-20px -24px -32px' }}
		>
			<PreConfiguredBlock
				piletApi={piral}
				configuration={{
					pluginId: 'urn:client-mgt-pilet',
					blockName: 'urn:block:client-mgt-pilet:client-contact-update',
					blockParameters: {
						contentPadding: '20px',
						clientRID,
						clientContactRID,
					},
				}}
			/>
		</div>
	);
};
